/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */

import React from 'react';
import { ContextMenu } from '@agconnections/grow-ui';

const withPermissionsEllipsisMenu = (
  WrappedComponent,
  menuList,
  wrappedProps,
  loggedInUserOrgPermission = {}
) => ({ skipPermissions = false }) => {
  const { role = '', financialAccess = 'none' } = loggedInUserOrgPermission;

  const Menu = menuList
    .filter(
      ({ rolesAllowed, financialAccessAllowed }) =>
        skipPermissions ||
        (rolesAllowed?.includes(role?.toLowerCase()) &&
          financialAccessAllowed?.includes(financialAccess?.toLowerCase()))
    )
    .map(({ value, text, className = '' }) => {
      return (
        <ContextMenu.Option
          value={value}
          key={value}
          onClick={wrappedProps.onDeleteClick}
        >
          <span className={className}>{text}</span>
        </ContextMenu.Option>
      );
    });

  return <WrappedComponent {...wrappedProps}>{Menu}</WrappedComponent>;
};

export default withPermissionsEllipsisMenu;
